import React from 'react';
import PropTypes from 'prop-types';

import styles from './ExploreCards.scss';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

class ExploreCards extends React.PureComponent {
  render() {
    const { type, items, tooltip } = this.props;
    const groups = this.props.groups || [
      {
        title: '',
        items,
      },
    ];

    return (
      <div className="ExploreCards">
        <div className="ExploreCards__container">
          <header className="ExploreCards__header" style={{ display: 'flex' }}>
            <h3 className="ExploreCards__section-title">
              <ConnectedFormattedMessage id={`${type}_cards.title`} />
            </h3>
            {tooltip}
          </header>
          {groups.map((group, i) => (
            <div className="ExploreCards__group" key={`group-${i}`}>
              {group.title ? (
                <h4 className="ExploreCards__group-title">{group.title}</h4>
              ) : null}
              <ul className="ExploreCards__items">{group.items}</ul>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

ExploreCards.propTypes = {
  type: PropTypes.string.isRequired,
  items: PropTypes.array,
  groups: PropTypes.array,
};

export default ExploreCards;
